<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "List" });
import "tailwindcss/tailwind.css";
export let mode = "numeric";
const TAGS = {
    checklist: "ul",
    numeric: "ol",
    simple: "ul"
};
</script>

    <svelte:element this = { TAGS[mode] } class = { `s8-list-${ mode }` }>
        <slot>
            <li>Hello World</li>
            <li>Hello World</li>
            <li>Hello World</li>
        </slot>
    </svelte:element>

<style>
    ol, ul {
        list-style: none;
        counter-reset: list-counter;
        margin-bottom: 40px;
    }

        ol :global(li), ul :global(li) {
            margin-bottom: 10px;
            padding-left: 30px;
            counter-increment: list-counter;
            position: relative;
        }

        ol :global(li):last-child, ul :global(li):last-child {
                margin-bottom: 0px;
            }

        ol :global(li)::before, ul :global(li)::before {
                position: absolute;
                left: 0px;
                top: -2px;
                min-width: 20px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                border-radius: 50%;
                background-color: rgba(255,255,255,1.0);
                box-shadow: 0 1px 0 0 rgba(39,39,17,0.06);
            }

        ol.s8-list-numeric :global(li::before), ul.s8-list-numeric :global(li::before) {
            content: counter(list-counter);
        }

        ol.s8-list-checklist :global(li::before), ul.s8-list-checklist :global(li::before) {
            content: '✅';
        }

        ol.s8-list-simple :global(li::before), ul.s8-list-simple :global(li::before) {
            content: '→';
        }</style>